<template>
  <div class="online-list-filters">
    <Field
      type="radio"
      name="enrollment_status"
      id="enrollment_status_enrolled"
      label="Show courses I'm currently ENROLLED in"
      class="custom-control custom-radio mb-1"
      v-model="enrollmentStatus"
      radio-value="enrolled"
    />
    <Field
      type="radio"
      name="enrollment_status"
      id="enrollment_status_never"
      label="Show courses I've NEVER enrolled in"
      class="custom-control custom-radio mb-1"
      v-model="enrollmentStatus"
      radio-value="never"
    />
    <Field
      type="radio"
      name="enrollment_status"
      id="enrollment_status_all"
      label="Show ALL courses"
      class="custom-control custom-radio mb-1"
      v-model="enrollmentStatus"
      radio-value="all"
    />
  </div>
</template>

<script>
export default {
    props: {
        value: {type: String, default: ""}
    },
    data() {
        return {
            enrollmentStatus: null
        };
    },
    watch: {
        value(val) {
            this.enrollmentStatus = val;
        },
        enrollmentStatus(val) {
            this.$emit("input", val);
        }
    },

    methods: {
        clearRadios() {
            this.enrollmentStatus = "";
        }
    },

    created() {
        this.enrollmentStatus = this.value;
        this.$root.eventBus.$on('clear-all-filters', this.clearRadios)
    },

    destroyed() {
        this.$root.eventBus.$off('clear-all-filters', this.clearRadios)
    }
};
</script>